<template>

  <div class="flex items-center">

    <button
      @click="$emit('loadPage', paging.prevPage)"
      :disabled="prevDisabled"
      class="text-xs bg-grey-lightest rounded p-2"
      :class="{ 'hover:bg-grey-light' : !prevDisabled, 'cursor-default' : prevDisabled }"
    >&lt;</button>

    <div class="text-xs px-4 py-2 whitespace-no-wrap">Page {{ paging.page }} of {{ paging.totalPages }}</div>

    <button
      @click="$emit('loadPage', paging.nextPage)"
      :disabled="nextDisabled"
      class="text-xs bg-grey-lightest rounded p-2"
      :class="{ 'hover:bg-grey-light' : !nextDisabled, 'cursor-default' : nextDisabled }"
    >&gt;</button>

  </div>

</template>

<script>
export default {

  name: 'MatchingPaging',

  props: {

    paging: { type: Object }

  },

  computed: {

    prevDisabled() {

      return !this.paging.prevPage;

    },

    nextDisabled() {

      return this.paging.page >= this.paging.totalPages;

    }

  },

  methods: {

    loadPage(page) {

      this.$emit('loadPage', page || 1);

    }

  }

}
</script>
